import { createAction } from '@ngrx/store';

export const popupManualClose = createAction('[Modal] manual close');
